import React, { useState, useEffect } from 'react';
import { Dialog } from '@mui/material';
import { editApproverLevel } from '../../../../redux/dashboardSlice';
import InputField from '../../../../Components/Input';
import CustomButton from '../../../../Components/CustomButton';

interface EditApproverLevelModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: (updatedLevelName?: string) => void;
  productionId?: string | null;
  levelIndex?: number;
  initialLevelName?: string;
}

const EditApproverLevelModal = ({
  open,
  onClose,
  onSuccess,
  productionId,
  levelIndex,
  initialLevelName,
}: EditApproverLevelModalProps): React.ReactElement => {
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const MAX_LENGTH = 50;

  const payload = {
    roleName: comment,
    productionId,
    levelIndex,
  };

  useEffect(() => {
    if (open) {
      setComment(initialLevelName ?? '');
    }
  }, [open, initialLevelName]);

  const handleSave = (): void => {
    if (!comment.trim()) return;
    setIsSubmitting(true);

    editApproverLevel(
      payload,
      (): void => {
        setIsSubmitting(false);
        const updatedLevelName = comment;
        onClose();
        onSuccess?.(updatedLevelName);
      },
      (): void => {
        setIsSubmitting(false);
      },
    );
  };

  return (
    <Dialog
      open={open}
      onClose={(): void => onClose()}
      maxWidth="xs"
      fullWidth
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="modal-dialog sm approver-level-modal">
        <div className="modal-content">
          <div className="modal-body pt-15 pb-15 pr-5 pl-5">
            <div className="">
              <p className="MuiTypography-body1 text-gray_700 fw500 text-center mb-8">
                Edit Approval Level
              </p>
              <div className="form-in lg">
                <InputField
                  id="editApprovalLevel"
                  name="editApprovalLevel"
                  placeholder="Name this approval level"
                  value={comment}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
                    setComment(e.target.value)
                  }
                  disabled={isSubmitting}
                  error={comment.length > MAX_LENGTH}
                  helperText={
                    comment.length > MAX_LENGTH
                      ? 'Role Name length must be less than or equal to 50 characters'
                      : `${comment.length}/${MAX_LENGTH}`
                  }
                />
              </div>
            </div>
            <div className="modal-actions full">
              <div>
                <CustomButton
                  variant="outlined"
                  onClick={(): void => onClose()}
                  size="large"
                  text={'Cancel'}
                  showIcon={false}
                  id={''}
                />
              </div>
              <div>
                <CustomButton
                  variant="contained"
                  onClick={(): void => handleSave()}
                  disabled={
                    !comment.trim() ||
                    comment.length > MAX_LENGTH ||
                    isSubmitting ||
                    comment.trim() === (initialLevelName ?? '').trim()
                  }
                  size="large"
                  text={isSubmitting ? 'Saving...' : 'Save'}
                  showIcon={false}
                  id={''}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default EditApproverLevelModal;
